import {
  CHAT_SLIDE_MOTION,
  setChatDrawerOpen,
  useChatPanel,
  useIsDesktop,
} from "../../lib/chat.js";
import chatLauncherIcon from "./chatLauncherIcon.svg";

/**
 * The chat tab (the Mystic7 Figma `Button` beside the sidebar): a 32px square, rounded on its left
 * side only, at the right edge of the screen 90px above the bottom. On a wide screen it toggles the
 * panel and rides its left edge while the panel is open; on a phone it opens the drawer, which
 * then covers it. It sits above the support-chat launcher's corner, so the two never overlap.
 * Below `md` the tab bar's Chat opens the drawer instead, so the tab is not shown there.
 */
export function ChatLauncher() {
  const isDesktop = useIsDesktop();
  const { desktopOpen, setDesktopOpen, mobileOpen } = useChatPanel();
  const docked = isDesktop && desktopOpen;

  if (!isDesktop && mobileOpen) return null;
  return (
    <button
      type="button"
      onClick={() => (isDesktop ? setDesktopOpen(!desktopOpen) : setChatDrawerOpen(true))}
      aria-label={docked ? "Hide chat" : "Open chat"}
      aria-expanded={isDesktop ? desktopOpen : undefined}
      className={`fixed bottom-[90px] z-30 flex size-8 items-center justify-center rounded-l-md bg-secondary shadow-xs transition-[right] max-md:hidden ${CHAT_SLIDE_MOTION} hover:brightness-110 ${
        docked ? "right-[319px]" : "right-0"
      }`}
    >
      {/* The icon's own fill is the design's white; drawn as a mask instead, it takes the theme's
          secondary-foreground, so it reads on any store's secondary color. */}
      <span
        aria-hidden
        className="size-4 bg-secondary-foreground"
        style={{
          maskImage: `url("${chatLauncherIcon}")`,
          maskSize: "contain",
          maskRepeat: "no-repeat",
        }}
      />
    </button>
  );
}
